import { defineMessages } from 'react-intl'

export default defineMessages({
    tableHeadTalent: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadTalent',
        defaultMessage: 'Talent',
    },
    tableHeadBuyouts: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadBuyouts',
        defaultMessage: 'Usages',
    },
    tableHeadPrice: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadPrice',
        defaultMessage: 'Total Price',
    },
    tableHeadCost: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadCost',
        defaultMessage: 'Total Cost',
    },
    tableHeadLiveSessionCost: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadLiveSessionCost',
        defaultMessage: 'LS cost',
    },
    tableHeadLiveSessionDates: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadLiveSessionDates',
        defaultMessage: 'LS dates',
    },
    tableHeadComment: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadComment',
        defaultMessage: 'Comment',
    },
    tableHeadService: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadService',
        defaultMessage: 'Service',
    },
    tableHeadStatus: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.tableHeadStatus',
        defaultMessage: 'Status',
    },
    noComment: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.noComment',
        defaultMessage: 'None',
    },
    downloadFile: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.downloadFile',
        defaultMessage: 'Download file',
    },
    noFiles: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.noFiles',
        defaultMessage: 'No files to download',
    },
    noData: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.noData',
        defaultMessage: 'No versions available',
    },
    duplicate: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.duplicate',
        defaultMessage: 'Duplicate',
    },
    edit: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.edit',
        defaultMessage: 'Edit',
    },
    preview: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.preview',
        defaultMessage: 'Preview',
    },
    noPreview: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.noPreview',
        defaultMessage: '-',
    },
    downloadAllFiles: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.downloadAllFiles',
        defaultMessage: 'Download all files',
    },
    sendRejectMessage: {
        id: 'containers.AuditionScopePage.components.SubmittedTable.sendRejectMessage',
        defaultMessage: 'Send reject message',
    }
})
